module.exports = __webpack_public_path__ + "img/013.363cda8c.jpg";